import type { components } from 'admination-react/api-schema'
import { fillPath, sendJson } from '@/core/api/http'
import { isRefusal } from './teilnehmerakte-staff'

type Schemas = components['schemas']

export type RueckzugWrite = Schemas['RueckzugWrite']
export type Rueckzug = Schemas['RueckzugRead']
export type RueckzugAufgehoben = Schemas['RueckzugAufgehobenRead']

export const GRUND_MAX = 200

export const ZURUECKGEZOGEN = 'teilnahme_zurueckgezogen'
export const NICHT_ZURUECKGEZOGEN = 'teilnahme_nicht_zurueckgezogen'

export const isZurueckgezogen = (error: unknown): boolean => isRefusal(error, ZURUECKGEZOGEN)
export const isNichtZurueckgezogen = (error: unknown): boolean => isRefusal(error, NICHT_ZURUECKGEZOGEN)

const pfad = (coachingId: string, aktion: 'zurueckziehen' | 'rueckzug-aufheben') =>
  fillPath(`/vergabe-portal/coaching/{coaching_id}/${aktion}`, { coaching_id: coachingId })

export function zurueckziehen(coachingId: string, { am, grund_art, grund }: RueckzugWrite): Promise<Rueckzug> {
  const body: RueckzugWrite = { am, grund_art, grund: grund_art === 'sonstiges' ? grund?.trim() || null : null }
  return sendJson<Rueckzug>(pfad(coachingId, 'zurueckziehen'), 'POST', body)
}

export function rueckzugAufheben(coachingId: string): Promise<RueckzugAufgehoben> {
  return sendJson<RueckzugAufgehoben>(pfad(coachingId, 'rueckzug-aufheben'), 'POST', {})
}
